import React from "react";
import { Navigate } from "react-router-dom";

// Cancel URL redirects straight back to the void. No intermediate screen.
export default function PaymentCancel() {
  return <Navigate to="/" replace />;
}
